// extracted by mini-css-extract-plugin
module.exports = {"container":"privacyPolicy_container__2MVSq","Row":"privacyPolicy_Row__11xoC","divPrivacyPolicy":"privacyPolicy_divPrivacyPolicy__1wn27"};